<template>
    <div class="container">
        <b-modal
            :model-value="modalCreaEcp"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="lg"
            :title="labels.newEcp"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Actual -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.actual }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select v-model="actual" class="form-input" :disabled="readOnly">
                            <option value="">{{ labels.select }}</option>
                            <option value="1">{{ labels.yes }}</option>
                            <option value="0">{{ labels.not }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Operación -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.operacion }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select v-model="operacion" class="form-input" :disabled="readOnly">
                            <option value="">{{ labels.select }}</option>
                            <option value="+">Suma</option>
                            <option value="-">Resta</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Contable -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.contable }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select v-model="contable" class="form-input" :disabled="readOnly">
                            <option value="">{{ labels.select }}</option>
                            <option value="1">{{ labels.yes }}</option>
                            <option value="0">{{ labels.not }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Criterio Cuenta - IGUAL QUE EditaCuentaEcp -->
                <template v-if="showCuenta">
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label">{{ labels.criterio }}</label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <div class="criterio-inputs-wrapper">
                                <b-form-input 
                                    v-model="critCuenta" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                    autocomplete="off"
                                    :placeholder="labels.criterioCuentaPlaceholder"
                                    @input="buscaCuenta"
                                    :disabled="readOnly"
                                />
                                <b-form-input 
                                    v-model="critDescripcion" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px;"
                                    autocomplete="off"
                                    :placeholder="labels.criterioDescripcionPlaceholder"
                                    @input="buscaDescripcion"
                                    :disabled="readOnly"
                                />
                            </div>
                        </b-col>
                    </b-row>

                    <!-- Tabla de Cuentas - IGUAL QUE EditaCuentaEcp -->
                    <div class="accounts-section mt-2">
                        <div v-if="listCuentasSelMul.length > 0" class="accounts-list mt-1">
                            <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                <b-button 
                                    size="sm"
                                    style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                    @click="toggleSelectAllCuentas"
                                    :disabled="readOnly"
                                >
                                    {{ selectAllCuentas ? labels.deselectAll : labels.selectAll }}
                                </b-button>
                                <span style="font-size: 13px; color: #6c757d;">
                                    {{ labels.selected }}: <strong>{{ listadoCuentas.length }}</strong> / {{ listCuentasSelMul.length }}
                                </span>
                            </div>

                            <div class="custom-scroll-table">
                                <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                    <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                        <tr>
                                            <th style="width: 120px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                {{ labels.account }}
                                            </th>
                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                {{ labels.description }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr 
                                            v-for="cuenta in listCuentasSelMul" 
                                            :key="cuenta.id"
                                            @click="!readOnly && toggleCuentaSelection(cuenta)"
                                            :class="{'table-active-blue': isCuentaSelected(cuenta)}"
                                            :style="readOnly ? 'cursor: default;' : 'cursor: pointer;'"
                                        >
                                            <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                <strong>{{ cuenta?.cuenta || '' }}</strong>
                                            </td>
                                            <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="cuenta.descripcion">
                                                {{ cuenta?.descripcion || '' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-else-if="!loadingCuentas" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <span class="text-muted" style="font-size: 13px;">{{ labels.noAccountsFound }}</span>
                        </div>

                        <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <b-spinner small class="mr-1"></b-spinner>
                            <span style="font-size: 13px;">{{ labels.loadingAccounts }}</span>
                        </div>
                    </div>
                </template>

                <!-- Formulación - CHECKBOX NATIVOS -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="showFormulacion">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.formulacion }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="d-flex flex-wrap align-items-center gap-3">
                            <div class="custom-checkbox-wrapper">
                                <input 
                                    type="radio"
                                    id="chk_sf_new"
                                    value="sf"
                                    v-model="chk"
                                    :disabled="readOnly"
                                />
                                <label for="chk_sf_new">Fila</label>
                            </div>
                            <div class="custom-checkbox-wrapper">
                                <input 
                                    type="radio"
                                    id="chk_sc_new"
                                    value="sc"
                                    v-model="chk"
                                    :disabled="readOnly"
                                />
                                <label for="chk_sc_new">Columna</label>
                            </div>
                            <div class="custom-checkbox-wrapper">
                                <input 
                                    type="radio"
                                    id="chk_c_new"
                                    value="c"
                                    v-model="chk"
                                    :disabled="readOnly"
                                />
                                <label for="chk_c_new">Celda</label>
                            </div>
                            <div class="custom-checkbox-wrapper">
                                <input 
                                    type="radio"
                                    id="chk_n_new"
                                    value="n"
                                    v-model="chk"
                                    :disabled="readOnly"
                                />
                                <label for="chk_n_new">Niif</label>
                            </div>
                            <div class="custom-checkbox-wrapper" v-if="administrador">
                                <input 
                                    type="radio"
                                    id="chk_m_new"
                                    value="m"
                                    v-model="chk"
                                    :disabled="readOnly"
                                />
                                <label for="chk_m_new">Manual</label>
                            </div>
                            <div class="custom-checkbox-wrapper" v-if="administrador">
                                <input 
                                    type="radio"
                                    id="chk_cons_new"
                                    value="cons"
                                    v-model="chk"
                                    :disabled="readOnly"
                                />
                                <label for="chk_cons_new">Ajuste Consol</label>
                            </div>
                            <div class="custom-checkbox-wrapper" v-if="administrador">
                                <input 
                                    type="radio"
                                    id="chk_ac_new"
                                    value="ac"
                                    v-model="chk"
                                    :disabled="readOnly"
                                />
                                <label for="chk_ac_new">Ajuste Combinado</label>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <!-- Suma Fila -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="showSumaFila">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">Suma Fila:</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="sumFila" type="text" class="form-input" :disabled="readOnly" />
                    </b-col>
                </b-row>

                <!-- Suma Columna -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="showSumaColumna">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">Suma Columna:</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input v-model="sumColumna" type="text" class="form-input" :disabled="readOnly" />
                    </b-col>
                </b-row>

                <!-- Celda -->
                <b-row class="d-flex align-items-center uniform-form-row" v-if="showCelda">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">Celda:</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <div class="d-flex gap-2">
                            <b-form-input v-model="celFila" type="number" class="form-input" style="max-width: 100px;" :disabled="readOnly" />
                            <b-form-input v-model="celColumna" type="number" class="form-input" style="max-width: 100px;" :disabled="readOnly" />
                        </div>
                    </b-col>
                </b-row>

                <!-- Niif - IGUAL QUE EditaCuentaEcp -->
                <template v-if="showNiif">
                    <!-- Filtro NIIF -->
                    <b-row class="d-flex align-items-center uniform-form-row">
                        <b-col cols="12" md="4" class="text-left uniform-label-col">
                            <label class="form-label" style="font-size: 14px; font-weight: 500; color: #495057;">
                                {{ labels.niifFilter }}
                            </label>
                        </b-col>
                        <b-col cols="12" md="8" class="text-left">
                            <div class="criterio-inputs-wrapper">
                                <b-form-input 
                                    v-model="critNiifCode" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px; margin-bottom: 6px;"
                                    autocomplete="off"
                                    :placeholder="labels.niifCodePlaceholder"
                                    @input="filtraNiifs"
                                    :disabled="readOnly"
                                />
                                <b-form-input 
                                    v-model="critNiifName" 
                                    type="text" 
                                    class="form-input"
                                    style="height: 34px; font-size: 13px;"
                                    autocomplete="off"
                                    :placeholder="labels.niifNamePlaceholder"
                                    @input="filtraNiifs"
                                    :disabled="readOnly"
                                />
                            </div>
                        </b-col>
                    </b-row>

                    <!-- Tabla de NIIFs -->
                    <div class="accounts-section mt-2">
                        <div v-if="listNiifFiltered.length > 0" class="accounts-list mt-1">
                            <div class="select-all-container mb-2 d-flex align-items-center justify-content-between">
                                <b-button 
                                    size="sm"
                                    style="background-color: #2e507a; border-color: #2e507a; font-size: 13px; padding: 4px 16px; border-radius: 4px; color: white;"
                                    @click="toggleSelectAllNiifs"
                                    :disabled="readOnly"
                                >
                                    {{ selectAllNiifs ? labels.deselectAll : labels.selectAll }}
                                </b-button>
                                <span style="font-size: 13px; color: #6c757d;">
                                    {{ labels.selected }}: <strong>{{ arrNiif.length }}</strong> / {{ listNiifFiltered.length }}
                                </span>
                            </div>

                            <div class="custom-scroll-table">
                                <table class="table table-sm table-hover" style="font-size: 13px; margin-bottom: 0;">
                                    <thead style="position: sticky; top: 0; background: #f8f9fa; z-index: 1;">
                                        <tr>
                                            <th style="width: 120px; font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                {{ labels.code }}
                                            </th>
                                            <th style="font-weight: 600; font-size: 12px; color: #495057; padding: 6px 8px;">
                                                {{ labels.niifName }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr 
                                            v-for="niif in listNiifFiltered" 
                                            :key="niif.id"
                                            @click="!readOnly && toggleNiifSelection(niif)"
                                            :class="{'table-active-blue': isNiifSelected(niif)}"
                                            :style="readOnly ? 'cursor: default;' : 'cursor: pointer;'"
                                        >
                                            <td style="padding: 5px 8px; border-radius: 8px 0 0 8px;">
                                                <strong>{{ niif?.niif || '' }}</strong>
                                            </td>
                                            <td style="padding: 5px 8px; border-radius: 0 8px 8px 0;" :title="niif.nameNiif">
                                                {{ niif?.nameNiif || '' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-else-if="listNiif.length > 0 && !loadingNiifs" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <span class="text-muted" style="font-size: 13px;">{{ labels.noNiifsMatch }}</span>
                        </div>

                        <div v-else-if="loadingNiifs" class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <b-spinner small class="mr-1"></b-spinner>
                            <span style="font-size: 13px;">{{ labels.loadingNiifs }}</span>
                        </div>

                        <div v-else class="text-center py-2" style="height: 150px; display: flex; align-items: center; justify-content: center;">
                            <span class="text-muted" style="font-size: 13px;">{{ labels.noNiifsAvailable }}</span>
                        </div>
                    </div>
                </template>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="clicked">
                        {{ labels.close }}
                    </b-button>
                    <b-button class="reset-btn-primary ml-2" @click="guardaCuenta" :disabled="readOnly">
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import EcpReporte from '../../services/EcpReporte';
import PlanConsolidacion from '../../services/PlanConsolidacion';

export default {
    name: "NewCuentaEcp",
    props: ['modalCreaEcp', 'vigComSelect', 'cuentasCreadas', 'readOnly'],
    data: () => ({
        administrador: false,
        contable: "",
        cuenta: "",
        actual: "",
        operacion: "",
        showCuenta: false,
        showFormulacion: false,
        chk: "",
        showSumaFila: false,
        showSumaColumna: false,
        showNiif: false,
        listNiif: [],
        listNiifFiltered: [],
        listLevel: [],
        arrNiif: [],
        selectAllNiifs: false,
        loadingNiifs: false,
        sumFila: "",
        sumColumna: "",
        listadoCuentas: [],
        listCuentas: [],
        listCuentasSelMul: [],
        selectAllCuentas: false,
        loadingCuentas: false,
        showCelda: false,
        celFila: "",
        celColumna: "",
        critCuenta: "",
        critDescripcion: "",
        critNiifCode: "",
        critNiifName: "",
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    newEcp: "Nuevo Detalle ECP",
                    infoTitle: "Crear nuevo detalle",
                    infoText: "Ingresa los datos del nuevo detalle ECP y guarda los cambios.",
                    select: "Seleccione...",
                    save: "Guardar",
                    close: "Cerrar",
                    contable: "Contable:",
                    yes: "SI",
                    not: "NO",
                    criterio: "Criterio:",
                    criterioCuentaPlaceholder: "Buscar por cuenta...",
                    criterioDescripcionPlaceholder: "Buscar por descripción...",
                    account: "Cuenta:",
                    description: "Descripción",
                    actual: "Actual:",
                    operacion: "Operación:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formulación:",
                    consolidado: "Consolidado",
                    selected: "Seleccionadas",
                    selectAll: "Seleccionar todas",
                    deselectAll: "Deseleccionar todas",
                    noAccountsFound: "No se encontraron cuentas",
                    loadingAccounts: "Cargando cuentas...",
                    selectedNiifs: "NIIF seleccionadas:",
                    niifFilter: "Filtro NIIF",
                    niifCodePlaceholder: "Buscar por código...",
                    niifNamePlaceholder: "Buscar por nombre...",
                    code: "Código",
                    niifName: "Nombre NIIF",
                    noNiifsAvailable: "No hay NIIF disponibles",
                    noNiifsMatch: "No hay NIIF que coincidan con el filtro",
                    loadingNiifs: "Cargando NIIF..."
                }
            } else {
                return {
                    newEcp: "New ECP Detail",
                    infoTitle: "Create new detail",
                    infoText: "Enter the new ECP detail data and save the changes.",
                    select: "Select...",
                    save: "Save",
                    close: "Close",
                    contable: "Accountant:",
                    yes: "YES",
                    not: "NO",
                    criterio: "Criterion:",
                    criterioCuentaPlaceholder: "Search by account...",
                    criterioDescripcionPlaceholder: "Search by description...",
                    account: "Account:",
                    description: "Description",
                    actual: "Actual:",
                    operacion: "Operation:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formulation:",
                    consolidado: "Consolidated",
                    selected: "Selected",
                    selectAll: "Select all",
                    deselectAll: "Deselect all",
                    noAccountsFound: "No accounts found",
                    loadingAccounts: "Loading accounts...",
                    selectedNiifs: "Selected NIIF:",
                    niifFilter: "NIIF Filter",
                    niifCodePlaceholder: "Search by code...",
                    niifNamePlaceholder: "Search by name...",
                    code: "Code",
                    niifName: "NIIF Name",
                    noNiifsAvailable: "No NIIF available",
                    noNiifsMatch: "No NIIF match the filter",
                    loadingNiifs: "Loading NIIF..."
                }
            }
        }
    },
    methods: {
        // ==== Métodos para Cuentas ====
        isCuentaSelected(cuenta) {
            return this.listadoCuentas.includes(cuenta?.cuenta);
        },

        toggleCuentaSelection(cuenta) {
            if (this.readOnly) return;
            if (!cuenta || !cuenta.cuenta) return;
            const cuentaStr = String(cuenta.cuenta);
            const index = this.listadoCuentas.findIndex(item => String(item) === cuentaStr);
            if (index > -1) {
                this.listadoCuentas.splice(index, 1);
            } else {
                this.listadoCuentas.push(cuenta.cuenta);
            }
            this.updateSelectAllCuentas();
        },

        toggleSelectAllCuentas() {
            if (this.readOnly) return;
            this.selectAllCuentas = !this.selectAllCuentas;
            const listadoCuentasStr = this.listadoCuentas.map(item => String(item));
            
            if (this.selectAllCuentas) {
                const allCodes = this.listCuentasSelMul.map(c => c?.cuenta).filter(code => code !== undefined && code !== null);
                allCodes.forEach(code => {
                    const codeStr = String(code);
                    if (!listadoCuentasStr.includes(codeStr)) {
                        this.listadoCuentas.push(code);
                    }
                });
            } else {
                const allCodes = this.listCuentasSelMul.map(c => c?.cuenta).filter(code => code !== undefined && code !== null);
                const codesStr = allCodes.map(c => String(c));
                this.listadoCuentas = this.listadoCuentas.filter(code => !codesStr.includes(String(code)));
            }
        },

        updateSelectAllCuentas() {
            if (this.listCuentasSelMul.length === 0) {
                this.selectAllCuentas = false;
                return;
            }
            const allCodes = this.listCuentasSelMul.map(c => c?.cuenta).filter(code => code !== undefined && code !== null);
            const listadoCuentasStr = this.listadoCuentas.map(item => String(item));
            this.selectAllCuentas = allCodes.every(code => listadoCuentasStr.includes(String(code)));
        },

        buscaCuenta() {
            if (this.critCuenta.length == 0) {
                this.listCuentasSelMul = [...this.listCuentas];
            } else {
                const criterio = "^" + this.critCuenta;
                this.listCuentasSelMul = this.listCuentas.filter(
                    (cuenta) => cuenta.cuenta && cuenta.cuenta.match(criterio)
                );
            }
            this.updateSelectAllCuentas();
        },

        buscaDescripcion() {
            if (this.critDescripcion.length == 0) {
                this.listCuentasSelMul = [...this.listCuentas];
            } else {
                const searchTerm = this.critDescripcion.toUpperCase();
                this.listCuentasSelMul = this.listCuentas.filter(
                    (cuenta) => cuenta.descripcion && 
                        cuenta.descripcion.toUpperCase().includes(searchTerm)
                );
            }
            this.updateSelectAllCuentas();
        },

        // ==== Métodos para NIIF ====
        isNiifSelected(niif) {
            if (!niif || niif.niif === undefined || niif.niif === null) return false;
            return this.arrNiif.some(item => String(item) === String(niif.niif));
        },

        toggleNiifSelection(niif) {
            if (this.readOnly) return;
            if (!niif || niif.niif === undefined || niif.niif === null) return;
            const niifStr = String(niif.niif);
            const index = this.arrNiif.findIndex(item => String(item) === niifStr);
            if (index > -1) {
                this.arrNiif.splice(index, 1);
            } else {
                this.arrNiif.push(niif.niif);
            }
            this.updateSelectAllNiifs();
        },

        toggleSelectAllNiifs() {
            if (this.readOnly) return;
            this.selectAllNiifs = !this.selectAllNiifs;
            const arrNiifStr = this.arrNiif.map(item => String(item));
            
            if (this.selectAllNiifs) {
                const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null);
                allCodes.forEach(code => {
                    const codeStr = String(code);
                    if (!arrNiifStr.includes(codeStr)) {
                        this.arrNiif.push(code);
                    }
                });
            } else {
                const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null);
                const codesStr = allCodes.map(c => String(c));
                this.arrNiif = this.arrNiif.filter(code => !codesStr.includes(String(code)));
            }
        },

        updateSelectAllNiifs() {
            if (this.listNiifFiltered.length === 0) {
                this.selectAllNiifs = false;
                return;
            }
            const allCodes = this.listNiifFiltered.map(n => n?.niif).filter(code => code !== undefined && code !== null);
            const arrNiifStr = this.arrNiif.map(item => String(item));
            this.selectAllNiifs = allCodes.every(code => arrNiifStr.includes(String(code)));
        },

        filtraNiifs() {
            let filtered = [...this.listNiif];
            
            if (this.critNiifCode) {
                const codeFilter = this.critNiifCode.toUpperCase();
                filtered = filtered.filter(n => {
                    const code = n?.niif;
                    if (code === undefined || code === null) return false;
                    return String(code).toUpperCase().includes(codeFilter);
                });
            }
            
            if (this.critNiifName) {
                const nameFilter = this.critNiifName.toUpperCase();
                filtered = filtered.filter(n => {
                    const name = n?.nameNiif;
                    if (name === undefined || name === null) return false;
                    return String(name).toUpperCase().includes(nameFilter);
                });
            }
            
            this.listNiifFiltered = filtered;
            this.updateSelectAllNiifs();
        },

        cargarNiif() {
            if (this.vigComSelect.vigencia == "") {
                this.$toast.error("El campo vigencia debe estar diligenciado");
                return;
            }
            
            this.loadingNiifs = true;
            
            PlanConsolidacion.getPlanConsPorCompVige(
                this.vigComSelect.vigencia,
                this.vigComSelect.codReporte
            )
            .then((res) => {
                const niifData = res.data.planConsNiif || [];
                this.listNiif = niifData;
                this.listNiifFiltered = [...niifData];
                this.updateSelectAllNiifs();
                this.loadingNiifs = false;
            })
            .catch((err) => {
                console.log(err);
                this.listNiif = [];
                this.listNiifFiltered = [];
                this.loadingNiifs = false;
            });
        },

        consCuentas(companyId, vigencia, codReporte) {
            let form = {
                'companyId': companyId,
                'vigencia': vigencia,
                'codReporte': codReporte,
                'actual': this.actual,
                'operacion': this.operacion,
                'fila': this.vigComSelect.fila,
                'columna': this.vigComSelect.columna,
                'contable': this.contable,
                'cuentasList': this.cuentasCreadas
            }

            EcpReporte.cuentasNoCreadas(form)
                .then((result) => {
                    this.listCuentas = result.data.cuentas
                    this.listCuentasSelMul = result.data.cuentas
                    this.showCuenta = true
                })
                .catch((err) => {
                    console.log(err)
                })
        },

        guardaCuenta() {
            if (this.readOnly) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para crear.')
                return
            }
            if (this.chk == 'n') {
                if (this.arrNiif.length == 0) {
                    this.$toast.error("Niif sin seleccionar")
                    return
                }
            }
            if (this.contable == 1 && this.listadoCuentas.length == 0) {
                this.$toast.error("Debe seleccionar al menos una cuenta")
                return
            }
            if (this.vigComSelect.vigencia == "") {
                this.$toast.error("El campo vigencia debe estar diligenciado")
            } else if (this.vigComSelect.companyId == "") {
                this.$toast.error("El campo compañía debe estar diligenciado")
            } else if (this.contable == "") {
                this.$toast.error("El campo contable debe estar diligenciado")
            } else if (this.actual == "") {
                this.$toast.error("El campo actual debe estar diligenciado")
            } else if (this.operacion == "") {
                this.$toast.error("El campo operación debe estar diligenciado")
            } else {
                let dataInfo = {
                    "vigencia": this.vigComSelect.vigencia,
                    "companyId": this.vigComSelect.companyId,
                    "codReporte": this.vigComSelect.codReporte,
                    "fila": this.vigComSelect.fila,
                    "columna": this.vigComSelect.columna,
                    "contable": this.contable,
                    "cuenta": this.contable == 1 ? this.listadoCuentas : "",
                    "actual": this.actual,
                    "operacion": this.operacion,
                    "formulacion": this.contable == 0 ? this.chk : "",
                    "formSumaFila": this.chk == "sf" ? this.sumFila : "",
                    "formSumaColumna": this.chk == "sc" ? this.sumColumna : "",
                    "formSumaCelda": this.chk == "c" ? this.celFila + ',' + this.celColumna : "",
                    "formNiif": this.chk == "n" ? this.arrNiif : "",
                    "formConsolidado": this.chk == "cons" ? "1" : "",
                    'idUser': this.$store.state.userId
                }
                EcpReporte.insertDetalleEcp(dataInfo)
                    .then((resp) => {
                        this.$toast.success(resp.data.message)
                        this.clearForm()
                    })
                    .catch((err) => {
                        console.log(err)
                        if (err.response.status == 412) {
                            this.$toast.error(err.response.data.message)
                        }
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.reloadTable()
                        }, 3000);
                    })
            }
        },

        clicked() {
            this.contable = ""
            this.actual = ""
            this.operacion = ""
            this.chk = ""
            this.showFormulacion = false
            this.showCuenta = false
            this.sumFila = ""
            this.sumColumna = ""
            this.arrNiif = []
            this.celFila = ""
            this.celColumna = ""
            this.critCuenta = ""
            this.critDescripcion = ""
            this.critNiifCode = ""
            this.critNiifName = ""
            this.listadoCuentas = []
            this.listCuentas = []
            this.listCuentasSelMul = []
            this.listNiif = []
            this.listNiifFiltered = []
            this.selectAllCuentas = false
            this.selectAllNiifs = false

            this.$emit('cierraMod', false);
        },

        reloadTable() {
            this.$emit('reloadTable', this.vigComSelect)
        },

        clearForm() {
            this.contable = ""
            this.actual = ""
            this.operacion = ""
            this.chk = ""
            this.sumFila = ""
            this.sumColumna = ""
            this.arrNiif = []
            this.celFila = ""
            this.celColumna = ""
            this.critCuenta = ""
            this.critDescripcion = ""
            this.critNiifCode = ""
            this.critNiifName = ""
            this.listadoCuentas = []
            this.listCuentas = []
            this.listCuentasSelMul = []
            this.listNiif = []
            this.listNiifFiltered = []
            this.selectAllCuentas = false
            this.selectAllNiifs = false
            this.showCuenta = false
            this.showFormulacion = false
            this.showSumaFila = false
            this.showSumaColumna = false
            this.showCelda = false
            this.showNiif = false
        }
    },
    mounted() {
        if (this.$route.name == "ecpReporteADM") {
            this.administrador = true
        }
    },
    watch: {
        contable(valNew) {
            if (valNew == 0) {
                this.showCuenta = false
                this.showFormulacion = true
                this.listCuentas = []
                this.listCuentasSelMul = []
                this.listadoCuentas = []
            } else if (valNew == 1) {
                this.showCuenta = true
                this.showFormulacion = false
                this.showSumaFila = false                
                this.chk = ""
                this.arrNiif = []
                this.consCuentas(this.vigComSelect.companyId, this.vigComSelect.vigencia, this.vigComSelect.codReporte)
            }
        },

        actual(valNewAct, valOldAct) {
            if (valNewAct != valOldAct && this.contable == 1) {
                this.showCuenta = false
                this.listadoCuentas = []
                this.consCuentas(this.vigComSelect.companyId, this.vigComSelect.vigencia, this.vigComSelect.codReporte)
            }
        },

        operacion(valNewOpe, valOldOpe) {
            if (valNewOpe != valOldOpe && this.contable == 1) {
                this.showCuenta = false
                this.listadoCuentas = []
                this.consCuentas(this.vigComSelect.companyId, this.vigComSelect.vigencia, this.vigComSelect.codReporte)
            }
        },

        chk(valNew) {
            this.listNiif = []
            if (valNew == 'n') {
                this.arrNiif = []
                this.cargarNiif()
                this.showNiif = true
                this.showSumaFila = false
                this.showSumaColumna = false
                this.showCelda = false
                this.sumFila = ""
                this.sumColumna = ""
                this.celFila = ""
                this.celColumna = ""
            } else if (valNew == 'sf') {
                this.showSumaFila = true
                this.showSumaColumna = false
                this.showCelda = false
                this.showNiif = false
                this.arrNiif = []
                this.sumColumna = ""
                this.sumFila = ""
                this.celFila = ""
                this.celColumna = ""
            } else if (valNew == 'sc') {
                this.showSumaColumna = true
                this.showSumaFila = false
                this.showCelda = false
                this.showNiif = false
                this.arrNiif = []
                this.celFila = ""
                this.celColumna = ""
            } else if (valNew == 'c') {
                this.showCelda = true
                this.showSumaFila = false
                this.showSumaColumna = false
                this.showNiif = false
                this.arrNiif = []
                this.sumFila = ""
                this.sumColumna = ""
            } else if (valNew == 'm' || valNew == 'cons' || valNew == 'ac') {
                this.showSumaFila = false
                this.showSumaColumna = false
                this.showNiif = false
                this.showCelda = false
                this.arrNiif = []
                this.sumFila = ""
                this.sumColumna = ""
                this.celFila = ""
                this.celColumna = ""
            }
        }
    }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* ========== ESTILOS PARA SELECTOR MÚLTIPLE ========== */
.criterio-inputs-wrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
}

.accounts-section {
    margin-top: 8px;
}

.select-all-container {
    padding: 4px 0;
}

.custom-scroll-table {
    height: 200px !important;
    min-height: 200px !important;
    max-height: 200px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    display: block !important;
    position: relative !important;
}

.custom-scroll-table table {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin-bottom: 0 !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
}

.custom-scroll-table table thead {
    display: table-header-group !important;
    width: 100% !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
}

.custom-scroll-table table thead tr {
    display: table-row !important;
    width: 100% !important;
}

.custom-scroll-table table thead th {
    background-color: #f8f9fa !important;
    border-bottom: 2px solid #dee2e6 !important;
    padding: 6px 8px !important;
    font-weight: 600 !important;
    font-size: 12px !important;
    color: #495057 !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
}

.custom-scroll-table table thead th:first-child {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
}

.custom-scroll-table table thead th:last-child {
    width: auto !important;
}

.custom-scroll-table table tbody {
    display: table-row-group !important;
    width: 100% !important;
}

.custom-scroll-table table tbody tr {
    display: table-row !important;
    width: 100% !important;
    cursor: pointer !important;
    border-radius: 8px !important;
}

.custom-scroll-table table tbody td {
    padding: 5px 8px !important;
    border: none !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
}

.custom-scroll-table table tbody td:first-child {
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
    border-radius: 8px 0 0 8px !important;
}

.custom-scroll-table table tbody td:last-child {
    width: auto !important;
    border-radius: 0 8px 8px 0 !important;
}

.custom-scroll-table table tbody tr:hover td {
    background-color: #f5f9ff !important;
}

.custom-scroll-table::-webkit-scrollbar {
    width: 8px !important;
}

.custom-scroll-table::-webkit-scrollbar-track {
    background: #f1f1f1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb {
    background: #c1c1c1 !important;
    border-radius: 4px !important;
}

.custom-scroll-table::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8 !important;
}

.table-active-blue {
    background-color: #e3f0ff !important;
    border-radius: 8px !important;
}

.table-active-blue td {
    background-color: #e3f0ff !important;
}

.table-active-blue td:first-child {
    border-radius: 8px 0 0 8px !important;
}

.table-active-blue td:last-child {
    border-radius: 0 8px 8px 0 !important;
}

/* CHECKBOX NATIVOS */
.custom-checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
}

.custom-checkbox-wrapper input[type="radio"] {
    width: 16px;
    height: 16px;
    accent-color: #2e507a;
    cursor: pointer;
    margin: 0;
    flex-shrink: 0;
}

.custom-checkbox-wrapper input[type="radio"]:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.custom-checkbox-wrapper label {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #495057;
    cursor: pointer;
}

.custom-checkbox-wrapper input[type="radio"]:disabled + label {
    cursor: not-allowed;
    opacity: 0.6;
}

/* Estilos generales del modal */
.uniform-modal-body {
    padding: 8px 4px 4px 4px;
}

.uniform-form-row {
    margin-bottom: 12px;
}

.uniform-label-col label {
    margin-bottom: 0;
    font-weight: 500;
    font-size: 14px;
}

.form-input {
    width: 100%;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

.gap-2 {
    gap: 8px;
}

.gap-3 {
    gap: 12px;
}

.password-policy-box {
    background: white;
    border-radius: 8px;
    padding: 16px 20px;
    border-left: 4px solid #2e507a;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.password-policy-title {
    font-weight: 600;
    font-size: 15px;
    color: #2e507a;
    margin-bottom: 4px;
}

.password-policy-subtitle {
    font-size: 13px;
    color: #6c757d;
}

.uniform-actions-wrap {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e9ecef;
}

.reset-btn-primary {
    background-color: #2e507a !important;
    border: 1px solid #2e507a !important;
    color: white !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-primary:hover:not(:disabled) {
    background-color: #1f3f62 !important;
    border-color: #1f3f62 !important;
}

.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.reset-btn-secondary {
    background-color: #f8f9fa !important;
    border: 1px solid #ced4da !important;
    color: #495057 !important;
    padding: 8px 24px;
    border-radius: 6px;
    font-weight: 500;
}

.reset-btn-secondary:hover:not(:disabled) {
    background-color: #e9ecef !important;
    border-color: #adb5bd !important;
}

.reset-modal-header {
    background-color: #2e507a;
    color: white;
    padding: 16px 20px;
    border-radius: 8px 8px 0 0;
}

.reset-modal-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
}

.reset-modal-body {
    padding: 24px 20px;
    background-color: #f8f9fa;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 768px) {
    .custom-scroll-table {
        height: 160px !important;
        min-height: 160px !important;
        max-height: 160px !important;
    }

    .custom-scroll-table table thead th:first-child,
    .custom-scroll-table table tbody td:first-child {
        width: 80px !important;
        min-width: 80px !important;
        max-width: 80px !important;
        font-size: 11px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 12px !important;
        padding: 4px 6px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 11px !important;
        padding: 4px 6px !important;
    }
}

@media (max-width: 576px) {
    .password-policy-box {
        padding: 12px 16px;
    }
    
    .password-policy-title {
        font-size: 14px;
    }
    
    .password-policy-subtitle {
        font-size: 13px;
    }
    
    .reset-dialog-actions {
        flex-direction: column;
    }
    
    .reset-dialog-actions .reset-btn-secondary,
    .reset-dialog-actions .reset-btn-primary {
        width: 100%;
        margin: 4px 0 !important;
    }

    .uniform-label-col {
        flex: 0 0 100%;
        max-width: 100%;
        margin-bottom: 4px;
        text-align: left !important;
    }
    
    .uniform-form-row .col-md-8 {
        flex: 0 0 100%;
        max-width: 100%;
    }

    .custom-scroll-table {
        height: 140px !important;
        min-height: 140px !important;
        max-height: 140px !important;
    }

    .custom-scroll-table table thead th:first-child,
    .custom-scroll-table table tbody td:first-child {
        width: 60px !important;
        min-width: 60px !important;
        max-width: 60px !important;
        font-size: 10px !important;
    }

    .custom-scroll-table table tbody td {
        font-size: 11px !important;
        padding: 3px 4px !important;
    }

    .custom-scroll-table table thead th {
        font-size: 10px !important;
        padding: 3px 4px !important;
    }

    .custom-checkbox-wrapper {
        gap: 4px;
    }

    .custom-checkbox-wrapper input[type="radio"] {
        width: 14px;
        height: 14px;
    }

    .custom-checkbox-wrapper label {
        font-size: 13px;
    }

    .gap-3 {
        gap: 8px;
    }
}
</style>